import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/chillnn/cn";

const dotsLoadingVariants = cva(
	"inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
	{
		variants: {
			bgColor: {
				default: "bg-white",
				zinc: "bg-zinc-800",
			},
		},
		defaultVariants: {
			bgColor: "default",
		},
	},
);

export interface DotsLoadingProps extends VariantProps<typeof dotsLoadingVariants> {}

export const DotsLoading = React.forwardRef<HTMLDivElement, DotsLoadingProps>(({ bgColor }, _ref) => {
	return (
		<div className="flex items-center justify-center gap-x-2">
			<span className="sr-only">読み込み中</span>
			<div
				className={cn(
					"h-2 w-2 animate-bounce rounded-full [animation-delay:-0.3s]",
					dotsLoadingVariants({ bgColor }),
				)}
			/>
			<div
				className={cn(
					"h-2 w-2 animate-bounce rounded-full [animation-delay:-0.15s]",
					dotsLoadingVariants({ bgColor }),
				)}
			/>
			<div className={cn("h-2 w-2 animate-bounce rounded-full", dotsLoadingVariants({ bgColor }))} />
		</div>
	);
});

DotsLoading.displayName = "DotsLoading";
